import Button from '@/components/Button';

/**
 * Promo code section component
 * @param {object} props
 * @param {object|null} props.promoApplied - Applied promo object
 * @param {string} props.promoId - Current promo code input value
 * @param {function} props.onPromoChange - Callback when promo code changes
 * @param {function} props.onApply - Callback when apply button is clicked
 * @param {function} props.onCancel - Callback when cancel button is clicked
 * @param {number} props.walletDiscount - Applied wallet discount amount
 * @param {function} props.onCancelWallet - Callback to cancel wallet discount
 */
const PromoCodeSection = ({ promoApplied, promoId, onPromoChange, onApply, onCancel, walletDiscount = 0, onCancelWallet }) => {
	const isWalletActive = walletDiscount > 0;
	const isDisabled = isWalletActive;

	return (
		<>
			{isWalletActive && !promoApplied && (
				<div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg col-span-2 md:col-span-1">
					<p className="text-sm text-gray-700 mb-2">
						Le code promotionnel n'est pas cumulable avec le portefeuille parrainage.{' '}
						{onCancelWallet && (
							<button
								type="button"
								onClick={onCancelWallet}
								className="text-sm text-blue-600 hover:text-blue-800 underline font-normal"
							>
								Annuler la réduction
							</button>
						)}
					</p>
				</div>
			)}

			<div className="p-2 flex flex-col items-center shadow-lg rounded-lg bg-white md:flex-row md:justify-around">
				<h3 className="text-left text-sm md:w-full">Code promotionnel / parrainage:</h3>

				{!promoApplied && (
					<input
						type="text"
						placeholder="Code promo"
						value={promoId || ''}
						onChange={(e) => onPromoChange(e.target.value.trim().toUpperCase())}
						disabled={isDisabled}
						className={`uppercase shadow-lg py-1 px-4 m-2 border border-black rounded-full w-4/5 text-xs md:text-md md:w-1/2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : ''}`}
					/>
				)}

				{promoApplied && (
					<h4 className="text-center text-sm md:w-full">{promoApplied.reference}</h4>
				)}

				<Button
					text={!promoApplied ? 'Appliquer' : 'Annuler'}
					type={'Button'}
					action="button"
					handleClick={!promoApplied ? onApply : onCancel}
					disabled={isDisabled || (promoId && promoId.trim().length > 0)}
					withTopMargin={false}
					extraClasses="capitalize text-xs md:text-sm"
				/>
			</div>
		</>
	);
};

export default PromoCodeSection;

